import React from "react";
import "./Contact.css";

export default function Contact() {
  return (
    <section id="contact">
      <div className="content">
        <div className="email-form">
          <form action="https://formspree.io/f/xzbydgbb" method="POST">
            <p>Want to get in touch, just let me know.</p>
            <div className="formSection">
              <label for="name" className="formLabel">
                Name
              </label>
              <input
                type="text"
                name="name"
                size="35"
                id="contactName"
                className="formInput"
                required
              />
              <br />
            </div>
            <div className="formSection">
              <label for="email" className="formLabel">
                Email
              </label>
              <input
                type="email"
                name="email"
                size="35"
                id="contactEmail"
                className="formInput"
                required
              />
              <br />
            </div>
            <div className="formSection">
              <label for="_subject" className="formLabel">
                Subject
              </label>
              <input
                type="text"
                name="_subject"
                size="35"
                id="contactSubject"
                className="formInput"
              />
              <br />
            </div>
            <div className="formSection">
              <label for="message" className="formLabel">
                Message
              </label>
              <textarea
                cols="50"
                rows="10"
                id="contactMessage"
                name="contactMessage"
                className="formInput"
                required
              ></textarea>
              <br />
            </div>
            <button type="submit" id="submitButton">
              Submit
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}
